module.exports = __webpack_public_path__ + "static/media/file-contract.2d9d0ed5.svg";